import { computed } from 'vue';
import useMainImageStore from '~/stores/useMainImageStore';
import { provideLocal, injectLocal } from '@vueuse/core';

const MAIN_IMAGE_INTERACTED: InjectionKey<ReturnType<typeof useMainImageInteractedProvide>> = Symbol.for('MAIN_IMAGE_INTERACTED');

/**
 * A composition function that provides reactive access to the `isMainImageInteracted` state.
 *
 * @returns An object containing a writable computed ref for `isMainImageInteracted`.
 */
export const useMainImageInteractedProvide = () => {
  const store = useMainImageStore();

  const isMainImageInteracted = computed({
    get() {
      return store.isMainImageInteracted;
    },
    set(value) {
      store.isMainImageInteracted = value;
    },
  });

  const stopAutoPlay = () => {
    isMainImageInteracted.value = true;
  };

  const toProvide = {
    isMainImageInteracted,
    stopAutoPlay,
  };

  provideLocal(MAIN_IMAGE_INTERACTED, toProvide);

  return toProvide;
};

export const useMainImageInteracted = () => injectLocal(MAIN_IMAGE_INTERACTED);
export default useMainImageInteracted;
